
<template>
  <div
    class="
      h-screen
      flex
      w-full
      bg-img
      vx-row
      no-gutter
      items-center
      justify-center
    "
    id="page-login"
  >
    <div class="vx-col sm:w-1/2 md:w-1/2 lg:w-3/4 xl:w-3/5 sm:m-0 m-4">
      <vx-card>
        <div slot="no-body" class="full-page-bg-color">
          <div class="vx-row no-gutter justify-center items-center">
            <div class="vx-col hidden lg:block lg:w-1/2">
              <div class="vx-row no-gutter justify-center items-center">
                <img
                  src="@/assets/images/logo/ilerno-logo.svg"
                  alt="login"
                  style="width: 350px"
                  class="mx-auto"
                />
              </div>
            </div>
            <div v-if="showForm" class="vx-col sm:w-full md:w-full lg:w-1/2 d-theme-dark-bg">

              <div
                class="p-8 pb-4 login-tabs-container"
                style="min-height: 100%"
              >
                <div class="vx-card__title mb-4">
                  <h2 class="mb-4"><b>Login with QR Code</b></h2>
                  <p class="error">{{ error }}</p>
                  <qrcode-stream @decode="onDecode" @init="onInit" />
                  <b>OR</b>
                  <p>
                    Logging in using parent account, please enter code
                    provided by the main device.
                  </p>
                </div>
                <div style="padding-top: 20px">
                  <div>

                    <form data-vv-scope="login">
                      <vs-input
                        size="large"
                        name="qrcode"
                        data-vv-name="QRCode"
                        v-validate="'required'"
                        icon-no-border
                        icon="icon icon-unlock"
                        icon-pack="feather"
                        placeholder="Code"
                        v-model="QRdata.qrcode"
                        class="w-full my-5"
                        @keyup.native.enter="login"
                      />
                      <span
                        class="text-danger text-sm"
                        v-show="errors.has('qrcode')"
                      >
                        {{ errors.first('qrcode') }}
                      </span>

                      <vs-divider>
                        <vs-button @click.prevent="login" class="float-right">
                          Link Device
                        </vs-button>
                      </vs-divider>
                      <div class="text-center">
                        Go back to
                        <a
                          class="primary cursor-pointer"
                          @click="$router.push('/')"
                        >
                          Sign In
                        </a>
                        page
                      </div>
                    </form>
                  </div>
                </div>
              </div>
              
            </div>
            <div v-else-if="showError">
              <vx-card>
              <h4 class="text-center">🚨 Error: Invalid Domain Detected! 🚨</h4><br>
              <p>It looks like the domain you entered might be incorrect.</p>
              <p>To fix this:</p>
              <p>Recheck the domain name for any typos or errors and ensure you're entering the correct domain.</p><br>

              <p><b>🛠 Need Help?</b></p>
              <p>Don't worry, we're here for you! Contact our support team at support@ilerno.com for personalized assistance.</p><br>
              <p>Thank You,</p>
              <p><b>The ilerno Support Team</b></p>

            </vx-card>
            </div>

          </div>
        </div>
      </vx-card>
    </div>
  </div>
</template>

<script>
import { loginWithQRApi, fetchCustomerDataBySubdomainAPI } from '@/api/login'
import { mapActions, mapGetters } from 'vuex'
import { QrcodeStream } from 'vue-qrcode-reader'
import { checkQrCode } from '@/api/login'
import { EachClientEdit } from '@/api/login'
import { URLMixins } from "@/mixins/url/url-with-domain";

export default {
  name: 'LoginWithDevice',
  mixins: [URLMixins],
  data () {
    return {
      subdomain: '',
      customerData : {
          customerId : '',
          customerName: '',
          customerDomain: ''
      },
      QRdata: {
        qrcode: '',
        generatedCode: false,
        device_info: {
          browser_type: '',
          device_type: ''
        }
      },
      error: '',
      message: '',
      showForm: false,
      showError: false,
    }
  },
  components: { QrcodeStream },
  computed: {
    ...mapGetters(['isClientLoggedIn'])
  },
  beforeMount () {
    //console.log(window.navigator)
    // const platform_type = window.navigator.userAgentData.platform
    // this.data.device_info = {
    //   browser_type: `Chrome on ${platform_type}`,
    //   device_type: ''
    // }
  },
  created () {
    console.log('ZP5NSCI')
    const hostname = window.location.hostname
    this.subdomain = hostname.split('.')[0]
    localStorage.setItem('subdomain', this.subdomain)
    this.fetchCustomerDataBySubdomain ()
  },
  mounted() {
    console.log('LoginWithDevice: mounted')
    this.subdomain = localStorage.getItem('subdomain')
    if(this.$route.query.qrcode){
      this.QRdata.qrcode = this.$route.query.qrcode
      this.$vs.loading({ text: 'Logging' })
      this.login()
    }
  },
  methods: {
    ...mapActions(['SetUser', 'SetUserDefaults']),
    async fetchCustomerDataBySubdomain () {
      this.$vs.loading({})

      const payload = {
        'subdomain' : this.subdomain,
      }

      await fetchCustomerDataBySubdomainAPI(payload)
        .then((response) => {

          const data = response.data.data.customerData
          if (data.id !== undefined ) {
            this.customerData.customerId = data.id
            this.customerData.customerName = data.brand_company_name
            this.customerData.customerDomain = data.subdomain_name

            this.showForm = true
          }

          this.$vs.loading.close()
        })
        .catch((apiError) => {
          this.$vs.loading.close()
          this.showError = true
          // console.log('fetchCustomerDataBySubdomainAPI err: ',apiError)
        })
        this.$vs.loading.close()
    },
    async makeid(length) {
      var result           = '';
      var characters       = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
      var charactersLength = characters.length;
      for ( var i = 0; i < length; i++ ) {
          result += characters.charAt(Math.floor(Math.random() * charactersLength));
      }
      
      try{
        const res = await checkQrCode({qrcode: result})
        this.$vs.loading.close()
        if(res.data.data.status){
          this.makeid(7)
        }else{
          console.log("======qr code", result)
          // XHR -->
          const customer_id = localStorage.getItem('customer_id');
          const user_id = localStorage.getItem('userId');
          const payload = {
            updateField: {
              qr_code: result
            }
          }
          const { data } = await EachClientEdit(user_id , customer_id, payload)
          

        }
      }catch(e){
        //this.$vs.loading.close()
        console.log(e)
      }
    },
    login () {
      this.$validator.validateAll('login').then((respone) => {
        if (respone) {
          this.$vs.loading({ text: 'Logging with QR Code, Please wait...' })
          const payload = {
            QRdata : this.QRdata,
            subdomain : this.subdomain
          }
          loginWithQRApi({
            ...this.QRdata,
            subdomain: this.subdomain
          })
          .then((data) => {

            // Navigate User to homepage
            const token = data.data.data.access_token;
            const user = data.data.data.user;
            const customer = data.data.data.subdomain;
            const type = data.data.data.type;

            const userString = JSON.stringify(user.id);
            const customerString = JSON.stringify(customer);

            if (token && user && customer && type) 
            {
              // Redirect to client portal URL
              const clientURL =
                                // this.makeUrlDomain('client') +
                                this.makeUrlDomain(customer.subdomain) +
                                  'client/redirect' +
                                  '?token=' + token +
                                  '&user=' + encodeURIComponent(userString) +
                                  '&customer=' + encodeURIComponent(customerString);

              window.location.href = clientURL;

            } else {
              reject({message: 'Wrong Email or Password'})
            }

            this.$vs.loading.close()
          })
          .catch((e) => {
            console.log("Error ====>", e)

            this.$vs.notify({
              title: 'Error',
              text: e.data.message,
              iconPack: 'feather',
              icon: 'icon-alert-circle',
              color: 'danger',
              time: 8000
            })

            this.$vs.loading.close()
          })
        } else {
          this.$vs.notify({
            title: 'Warning',
            text: 'Validation Is Required',
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'warning',
            time: 8000
          })
        }
      })
    },
    redirectUser () { 
      this.$router.push({ name: 'dashboard' }).catch(() => { })
    },
    onDecode (result) {
      console.log(result);
      let arr = result.split("=")
      this.QRdata.qrcode = arr[1]
      console.log(this.QRdata.qrcode)
      this.login()
    },
    async onInit (promise) {
      try {
        await promise
      } catch (error) {
        if (error.name === 'NotAllowedError') {
          this.error = "ERROR: you need to grant camera access permission"
        } else if (error.name === 'NotFoundError') {
          this.error = "ERROR: no camera on this device"
        } else if (error.name === 'NotSupportedError') {
          this.error = "ERROR: secure context required (HTTPS, localhost)"
        } else if (error.name === 'NotReadableError') {
          this.error = "ERROR: is the camera already in use?"
        } else if (error.name === 'OverconstrainedError') {
          this.error = "ERROR: installed cameras are not suitable"
        } else if (error.name === 'StreamApiNotSupportedError') {
          this.error = "ERROR: Stream API is not supported in this browser"
        } else if (error.name === 'InsecureContextError') {
          this.error = 'ERROR: Camera access is only permitted in secure context. Use HTTPS or localhost rather than HTTP.';
        } else {
          this.error = `ERROR: Camera error (${error.name})`;
        }
      }
    }
  }
}
</script>

<style lang="scss">
.login-tabs-container {
  min-height: 505px;

  .con-tab {
    padding-bottom: 14px;
  }

  .con-slot-tabs {
    margin-top: 1rem;
  }

  .rounded-circle {
    border-radius: 50%;
    width: 40px;
    height: 37px;
  }
}
</style>